var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dataTables_length d-flex"},[_c('label',{staticClass:"mt-4 pt-3 mr-4"},[_vm._v(_vm._s(_vm.title))]),_c('mdb-select',{attrs:{"wrapperClass":'mdb-select',"options":_vm.options},on:{"getValue":_vm.getOptionValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }